import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { ProductStateType } from '@redux/types'
import { ProductUpdateType, ProductType, BomType, BomBatchUpdateType } from '@schemas'

// initial state
const initialState: ProductStateType = {
	// trigger
	triggerInitProductPage: false,

	products: [],
	selectedProduct: null,
	boms: [],

	loading: false,
	error: null,

	// item
	updateItem: {
		iudFlag: 'I',
		id: '',
		code: '',
		name: '',
		usd: 0,
		krw: 0,
		discountUsd: 0,
		discountKrw: 0,
		materialCostUsd: null,
		materialCostKrw: null,
		index: 0,
		quantity: 0,
		useYn: 0,
		alwaysAvailableYn: 0,
		soldoutYn: 0,
	},
}

const slice = createSlice({
	name: 'product',
	initialState,
	reducers: {
		TRIGGER_INIT_PRODUCT_PAGE: (state, action: PayloadAction<boolean>) => {
			state.loading = true
			state.triggerInitProductPage = action.payload
		},
		TRIGGER_INIT_PRODUCT_PAGE_SUCCESS: state => {
			state.loading = false
		},
		TRIGGER_INIT_PRODUCT_PAGE_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
			state.loading = false
		},

		SET_PRODUCT_LIST: (state, action: PayloadAction<ProductType[]>) => {
			state.products = action.payload
		},
		SET_SELECTED_PRODUCT: (state, action: PayloadAction<ProductType | null>) => {
			state.selectedProduct = action.payload
		},

		REGISTER_PRODUCT: (
			state,
			action: PayloadAction<{
				name: string
				code: string
				usd: number
				index: string
				useYn: boolean
			}>,
		) => {
			state.loading = true
		},
		REGISTER_PRODUCT_SUCCESS: state => {
			state.loading = false
		},
		REGISTER_PRODUCT_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
			state.loading = false
		},

		UPDATE_PRODUCT: (state, action: PayloadAction<ProductUpdateType>) => {
			state.loading = true
		},
		UPDATE_PRODUCT_SUCCESS: state => {
			state.loading = false
		},
		UPDATE_PRODUCT_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
			state.loading = false
		},
		// 상품 삭제 관련
		DELETE_PRODUCT: (state, action: PayloadAction<string>) => {
			state.loading = true
		},
		DELETE_PRODUCT_SUCCESS: (state, action: PayloadAction<string>) => {
			state.products = state.products.filter(product => product.id !== action.payload)
			state.loading = false
		},
		DELETE_PRODUCT_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
			state.loading = false
		},
		// BOM 리스트 관련
		SET_BOM_LIST: (state, action: PayloadAction<BomType[]>) => {
			state.boms = action.payload
		},
		FETCH_BOM: (state, action: PayloadAction<string>) => {
			// This action will be handled in the saga
		},
		// New action for batch updating BOMs
		BATCH_UPDATE_BOM: (state, action: PayloadAction<BomBatchUpdateType[]>) => {
			// This action will be handled in the saga
		},
		BATCH_UPDATE_BOM_SUCCESS: state => {
			// This action will be handled in the saga
		},
		BATCH_UPDATE_BOM_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
		},

		UPDATE_ITEM: (
			state: ProductStateType,
			action: PayloadAction<ProductStateType['updateItem']>,
		) => {
			state.updateItem = action.payload
		},
	},
})

export const productActions = slice.actions
export default slice.reducer
